import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/configureStore';
import * as Styled from './ThemeSelector.styled';
import { ThemeList } from 'store/ducks/globalTypes';
import { variablesList } from 'constants/variablesList';

export interface IThemeSelectorProps {
  children: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  theme: ThemeList;
}

const ThemeSelector: React.FC<IThemeSelectorProps> = ({ children }) => {
  const { scheme } = useSelector((state: RootState) => state.global);
  const safeScheme = (scheme in variablesList
    ? scheme
    : 'mainTheme') as unknown as ThemeList;

  return (
    <>
      <Styled.ThemeContainer theme={safeScheme} data-theme={safeScheme}>
        {children}
      </Styled.ThemeContainer>
    </>
  );
};

export default ThemeSelector;
